export const getFormattedClients = clients =>
  clients.map(client => ({
    ...client,
    // ISO dates sort as text. A client without prompts goes to the end of "latest first".
    lastUpdated:
      [
        client.precisionConversation.updatedOn,
        client.precisionMeeting.updatedOn,
      ]
        .filter(Boolean)
        .sort()
        .pop() ?? '',
  }));
